import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  departmentAction,
  lobAction,
  modalAction,
} from './../../actions/'
import {
  authSelector,
  lobSelector,
  departmentSelector,
  modalSelector,
} from './../../selectors'
import { searchDepartments } from '../../function'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditDepartment from './edit'
import ListDepartment from './list'
import DepartmentForm from '../../components/department'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'

class DepartmentPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      id: '',
      span: false,
      department_code: '',
      department: '',
      lob_id: '',
      start_date: '',
      search: '',
      defaultDepartments: [],
      departments: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.lobList(access_token)
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'listDepartmentData') && this.state.search === '') {
      this.setState({
        departments: get(nextProps, 'listDepartmentData'),
        defaultDepartments: get(nextProps, 'listDepartmentData'),
      })
    }

    if (get(nextProps, 'departmentCreate.departmentCreate')) {
      this.props.showModal(
        'department',
        get(nextProps, 'departmentCreate.status'),
        get(nextProps, 'departmentCreate.message')
      )
      this.props.listDepartment(localStorage.getItem('access_token'))
      this.props.resetCreateDepartment()
    }
    if (get(nextProps, 'departmentEdit.departmentEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'department',
        get(nextProps, 'departmentEdit.status'),
        get(nextProps, 'departmentEdit.message')
      )
      if (get(nextProps, 'departmentEdit.status') === 200) this.showSave()
      this.props.listDepartment(localStorage.getItem('access_token'))
      this.props.resetEditDepartment()
      this.handleClickEdit(false, '')
    }
    if (get(nextProps, 'departmentDeactivate.departmentDeactivate')) {
      this.props.showConfirm(
        'deleteDepartment',
        get(nextProps, 'departmentDeactivate.status'),
        get(nextProps, 'departmentDeactivate.message')
      )
      this.props.listDepartment(localStorage.getItem('access_token'))
      this.props.resetDeactivateDepartment()
    }
    if (get(nextProps, 'exportURL')) {
      window.open(get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportDepartment()
    }
  }
  handleClickSearch() {
    this.setState({ departments: get(this.state, 'defaultDepartments').filter(searchDepartments, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ departments: get(this.state, 'defaultDepartments'), search: '' })
    else this.setState({ search: e.target.value })
  }

  handleClickEdit(editDepartment, department_id) {
    this.setState({
      edit: editDepartment,
      id: department_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your department information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('departmentForm')
  }
  cancelForm() {
    this.props.hideModal('departmentForm')
  }
  cancelAlert() {
    this.props.hideModal('dapartment')
  }
  submitForm() {
    this.props.createDepartment(
      {
        department_code: this.state.department_code,
        name: this.state.department,
        lob_id: get(this.state, 'lob_id') === '' ? get(this.props, 'listLOBData')[0]._id : get(this.state, 'lob_id'),
        start_date: this.state.start_date === '' ? '' : moment(this.state.start_date),
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectDepartment.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectDepartment.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingDepartment')
    || get(this.props, 'getIsFetchingLOB')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportDepartment(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          get(this.props, 'modalType') === 'department' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ get(this.props, 'modalType') === 'department' }
              type={ get(this.props, 'modalStatus') }
              message={ get(this.props, 'modalMessage') }
            />
        }
        {
          get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'confirmSave' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          get(this.props, 'confirmType') === 'deleteDepartment' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'deleteDepartment' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListDepartment
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              departments={ this.state.departments }
              table={ 2 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditDepartment
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ get(this.props, 'confrimType') }
                confirmStatus={ get(this.props, 'confirmStatus') }
                confirmType={ get(this.props, 'confirmType') }
                confirmMessage={ get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ get(this.props, 'modalType') === 'departmentForm' } toggle={ this.cancelForm }>
          <DepartmentForm
            create={ true }
            list={ get(this.props, 'listLOBData') }
            button={ button }
            department_code={ this.state.department_code }
            department={ this.state.department }
            lob_id={ this.state.lob_id }
            start_date={ this.state.start_date }
            confirm={ get(this.props, 'modalType') }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            cancelForm={ this.cancelForm }
            modalStatus={ get(this.props, 'modalStatus') }
            modalType={ get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

DepartmentPage.propTypes = {
  createDepartment: PropTypes.func.isRequired,
  resetCreateDepartment: PropTypes.func.isRequired,
  listDepartment: PropTypes.func.isRequired,
  resetEditDepartment: PropTypes.func.isRequired,
  resetDeactivateDepartment: PropTypes.func.isRequired,
  lobList: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  redirectAuth: authSelector.redirectAuth,
  redirectDepartment: departmentSelector.redirectDepartment,
  getIsFetchingLOB: lobSelector.getIsFetching,
  getIsFetchingDepartment: departmentSelector.getIsFetching,
  listLOBData: lobSelector.getListLOB,
  listDepartmentData: departmentSelector.getListDepartment,
  departmentCreate: departmentSelector.getCreateDepartmentData,
  departmentEdit: departmentSelector.getEditDepartmentData,
  departmentGet: departmentSelector.getGetDepartmentData,
  departmentDeactivate: departmentSelector.getDeactivateDepartmentData,
  exportURL: departmentSelector.getExportURL,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createDepartment: departmentAction.createDepartment,
  resetCreateDepartment: departmentAction.resetCreateDepartment,
  resetEditDepartment: departmentAction.resetEditDepartment,
  resetDeactivateDepartment: departmentAction.resetDeactivateDepartment,
  listDepartment: departmentAction.getDepartment,
  lobList: lobAction.getLOB,
  exportDepartment: departmentAction.exportDepartment,
  resetExportDepartment: departmentAction.resetExportDepartment,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(DepartmentPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/department/index.js